module.exports = __webpack_public_path__ + "static/media/PM141.6f87c978.png";